var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo-container",attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png"),"alt":"Ustecka Karta Mieszkańca - Strona główna"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }